import Link from 'next/link';
import { routes } from '../../../env/routes';
import { Event } from '../../../types/nexudus/events';
import { Button } from '@common/bw-ui/ui/button';

interface Props {
  event: Event;
}

export const EventCardCTA: React.FC<Props> = ({ event }) => {
  const { SoldOut, EnableWaitList, TicketsPage, HasTickets } = event;

  if (TicketsPage && !HasTickets) {
    return (
      <Button asChild size="lg" variant="primary-outline" className="tw:w-full">
        <Link href={TicketsPage} target="_blank">
          <i className="icon-external-link fs-20" />
          Sign up
        </Link>
      </Button>
    );
  }

  if (!HasTickets) {
    return null;
  }

  if (SoldOut) {
    if (EnableWaitList) {
      return (
        <Button
          asChild
          size="lg"
          variant="primary-outline"
          className="tw:w-full"
        >
          <Link href={routes.event_waiting_list_by_id(event)}>
            Join waitlist
          </Link>
        </Button>
      );
    }

    return (
      <Button disabled size="lg" variant="secondary" className="tw:w-full">
        Sold out
      </Button>
    );
  }

  return (
    <Button asChild size="lg" variant="primary-outline" className="tw:w-full">
      <Link href={routes.tickets_by_id(event)}>Sign up</Link>
    </Button>
  );
};
